import type { Creator } from '../core/types/site'

export type { Creator }

export const creators: Creator[] = [
  {
    name: 'Fleur Kramer',
    handle: '@fleurkramer',
    role: 'Redacteur Women’s Health',
    quote:
      'Sarah is de enige die me eerlijk vertelde dat de helft van mijn kast weg kon. Dit serum bleef, en mijn pigment is zichtbaar rustiger.',
    image:
      'https://cdn.magicpatterns.com/uploads/gixDmFYTUQBuLWRvyJprdG/18324627148173462-s-80-400.jpg',
    pickId: 'emerginc-vitamine-c-serum',
    code: 'FLEUR10',
  },
  {
    name: 'Iris de Wit',
    handle: '@gowiththeglow',
    role: 'Podcast Go With The Glow',
    quote:
      'Ik gebruik deze moisturiser al twee winters. Mijn huid loopt niet meer rood aan tijdens het sporten.',
    image:
      'https://cdn.magicpatterns.com/uploads/m4i5JC6c4qT7zLae7QU6Hb/18173167903394575-s-80-400.jpg',
    pickId: 'emerginc-hyper-vitalizer-cream',
    code: 'GLOW10',
  },
  {
    name: 'Noor Bakker',
    handle: '@noorbewust',
    role: 'Yoga docent & klant sinds 2021',
    quote:
      'Na mijn bindweefselkuur gaf Sarah me dit olietje mee. Drie weken later zag mijn huid er nog steeds uit alsof ik net uit de salon kwam.',
    image:
      'https://cdn.magicpatterns.com/uploads/azzLeCawxKA2qtysfHbXME/18113845093809152-s-80-400.jpg',
    pickId: 'rawceuticals-facial-oil',
    code: 'NOOR10',
  },
]
